<template>
  <div class="scroll-container">
    <button  @click="scroll(-1)">向左</button>
    <div class="scroll-list" ref="wrapperCon" @scroll="handleScroll">
      <!-- 列表项 -->
      <div v-for="item in items" :key="item.id" class="list-item">
        {{ item.text }}
      </div>
    </div>
    <button  @click="scroll(1)">向右</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: '苹果1'
        },
        {
          text: '苹果2'
        },
        {
          text: '苹果苹果3'
        },
        {
          text: '苹果4'
        },
        {
          text: '苹果5'
        },
        {
          text: '苹果6'
        },
        {
          text: '苹果苹果7'
        },
        {
          text: '苹果8'
        },
        {
          text: '平板电脑9'
        },
        {
          text: '苹果10'
        },
        {
          text: '苹果11'
        },
        {
          text: '苹果苹果12'
        },
        {
          text: '苹果13'
        },
        {
          text: '苹果14'
        },
        {
          text: '苹果15'
        },
        {
          text: '苹果苹果16'
        },
        {
          text: '苹果17'
        },
        {
          text: '平板电脑'
        }
      ], // 示例数据结构，根据实际情况调整
      canScrollLeft: true,
      canScrollRight: true, // 初始状态，根据实际情况调整
    };
  },
  methods: {
    handleScroll() {
      const scrollList = this.$refs.wrapperCon;
      this.canScrollLeft = scrollList.scrollLeft > 0; // 如果已经滚动，则显示向左按钮
      this.canScrollRight = scrollList.scrollLeft < scrollList.scrollWidth - scrollList.clientWidth; // 如果未滚动到最右，则显示向右按钮
    },
    scroll(direction) {
      const scrollList = this.$refs.wrapperCon;
      if (direction === -1 && scrollList.scrollLeft > 0) { // 向左滚动
        // 保存滚动盒子左侧已滚动的距离
        let left = this.$refs.wrapperCon.scrollLeft
        let num = 0
        clearInterval(this.timer)
        this.timer = null
        this.timer = setInterval(() => {
          //   !left:已经滚动到最左侧
          //   一次性滚动距离（可调节）
          if (!left || num >= 100) {
          // 停止滚动
          clearInterval(this.timer)
          this.timer = null
          return
          }
          // 给滚动盒子元素赋值向左滚动距离
          this.$refs.wrapperCon.scrollLeft = left -= 30
          // 保存向左滚动距离（方便判断一次性滚动多少距离）
          num += 30
        }, 50)
      } else if (direction === 1 && scrollList.scrollLeft < scrollList.scrollWidth - scrollList.clientWidth) { // 向右滚动
        // 保存滚动盒子左侧已滚动的距离
        let left = this.$refs.wrapperCon.scrollLeft
        // 保存元素的整体宽度
        let scrollWidth = this.$refs.wrapperCon.scrollWidth
        // 保存元素的可见宽度
        let clientWidth = this.$refs.wrapperCon.clientWidth
        let num = 0
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          // 已经滚动距离+可见宽度
          // left+clientWidth>=scrollWidth：滚动到最右侧
            // num>=100一次性滚动距离
            if (left + clientWidth >= scrollWidth || num >= 100) {
                clearInterval(this.timer)
                return
            }
            // 给滚动盒子元素赋值向左滚动距离
            this.$refs.wrapperCon.scrollLeft = left += 30
            // 保存向左滚动距离（方便判断一次性滚动多少距离）
            num += 30
          }, 50)
          // 20：速度（可调节）
        }
      this.handleScroll(); // 更新按钮状态
    },
  },
  mounted() {
    this.handleScroll(); // 组件挂载后立即检查一次滚动状态
  }
};
</script>
<style>
.scroll-container {
  display: flex;
  align-items: center;
}
.scroll-list {
  overflow-x: auto;
  width: 100%; /* 或者具体的宽度 */
  display: flex;
  white-space: nowrap;
}
.list-item {
  /* min-width: 100px; 根据需要调整 */
  padding: 10px;
  box-sizing: border-box;
  margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/demo.vue